'use-client';
import * as React from 'react';
import WPhoto from '../../WPhotoBase';
import type { SkinWPhotoProps } from '../SkinWPhoto';
import type { BaseWPhotoSkinProps } from '../../../WPhoto.types';
import skinsStyles from './styles/LiftedTopPhoto.scss';
import BasicWPhotoSkin from './BasicWPhotoSkin';

const LiftedTopPhotoSkin: React.FC<
  Omit<BaseWPhotoSkinProps, 'skinsStyle'>
> = props => <BasicWPhotoSkin {...props} skinsStyle={skinsStyles} />;

const LiftedTopPhoto: React.FC<SkinWPhotoProps> = props => (
  <WPhoto {...props} skin={LiftedTopPhotoSkin} />
);

export default LiftedTopPhoto;
